/**
 * Aktuality – psaní novinek pro veřejný web.
 * Co se zde napíše a odešle, objeví se ihned na veřejném webu
 * amatiband.ozvuceniplzen.cz (tabulka web_news). Psát a upravovat může
 * kterýkoli přihlášený muzikant; MAZAT smí jen správce (admin).
 * Seznam ukazuje všechny aktuality tak, jak jsou na veřejném webu.
 */
import { supabase } from '../lib/supabase.js';
import { isAdmin } from '../lib/auth.js';

function esc(s) {
    if (s == null) return '';
    return String(s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;')
        .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

function fmtDate(d) {
    if (!d) return '';
    const dt = new Date(d);
    return `${dt.getDate()}. ${dt.getMonth() + 1}. ${dt.getFullYear()}`;
}

function excerpt(text, len = 160) {
    const t = (text || '').replace(/\s+/g, ' ').trim();
    return t.length > len ? t.slice(0, len) + '…' : t;
}

export async function renderAktuality(container) {
    container.innerHTML = '<div class="state-banner">Načítám…</div>';

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
        container.innerHTML = '<div class="state-banner">Nejdřív se přihlas.</div>';
        return;
    }

    const admin = await isAdmin();

    const { data, error } = await supabase
        .from('web_news').select('*')
        .order('published_at', { ascending: false, nullsFirst: false })
        .order('created_at', { ascending: false });

    if (error) {
        container.innerHTML = `<div class="state-banner error">Chyba: ${esc(error.message)}</div>`;
        return;
    }

    const news = data || [];

    container.innerHTML = `
        <div class="filters">
            <h2 style="font-size:18px; margin-right:auto;">Aktuality</h2>
            <span style="font-size:13px;color:var(--text-muted);">
                ${news.length} ${news.length === 1 ? 'aktualita' : (news.length < 5 ? 'aktuality' : 'aktualit')}
            </span>
        </div>

        <form id="news-form" class="news-form">
            <label class="se-field">
                <span>Nadpis nové aktuality</span>
                <input type="text" name="title" required maxlength="160"
                       placeholder="např. Zahráli jsme v Líšině u Stoda">
            </label>
            <label class="se-field" style="margin-top:12px;">
                <span>Text aktuality</span>
                <textarea name="body" rows="5" required
                          placeholder="Co se stalo, jak to bylo…"></textarea>
            </label>
            <div style="display:flex; align-items:center; gap:12px; margin-top:12px;">
                <button class="btn btn-primary" type="submit">Odeslat na web</button>
                <span style="font-size:13px;color:var(--text-muted);">
                    Po odeslání se aktualita ihned zobrazí na veřejném webu.
                </span>
            </div>
            <p id="news-err" style="color:var(--accent); font-size:13px; margin-top:10px; display:none;"></p>
        </form>

        <div class="news-admin-list" style="margin-top:8px;">
            ${news.length === 0
                ? '<div class="state-banner">Zatím žádné aktuality. Napiš první výše.</div>'
                : news.map((n) => renderNewsRow(n, admin)).join('')}
        </div>
    `;

    const form = container.querySelector('#news-form');
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const errEl = container.querySelector('#news-err');
        errEl.style.display = 'none';

        const fd = new FormData(form);
        const title = fd.get('title').trim();
        const body = fd.get('body').trim();
        if (!title || !body) {
            errEl.textContent = 'Vyplň prosím nadpis i text.';
            errEl.style.display = 'block';
            return;
        }

        const btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;
        btn.textContent = 'Odesílám…';

        const { error: insErr } = await supabase.from('web_news').insert({
            title,
            body,
            published: true,
            published_at: new Date().toISOString()
        });

        if (insErr) {
            errEl.textContent = 'Odeslání selhalo: ' + insErr.message;
            errEl.style.display = 'block';
            btn.disabled = false;
            btn.textContent = 'Odeslat na web';
            return;
        }
        renderAktuality(container);
    });

    container.querySelectorAll('[data-del]').forEach((btn) => {
        btn.addEventListener('click', async () => {
            const n = news.find((x) => x.id === btn.dataset.del);
            if (!n) return;
            if (!confirm(`Smazat aktualitu „${n.title}"? Zmizí i z veřejného webu.`)) return;
            const { error: delErr } = await supabase.from('web_news').delete().eq('id', n.id);
            if (delErr) { alert('Smazání selhalo: ' + delErr.message); return; }
            renderAktuality(container);
        });
    });

    container.querySelectorAll('[data-edit]').forEach((btn) => {
        btn.addEventListener('click', () => {
            const n = news.find((x) => x.id === btn.dataset.edit);
            if (n) openNewsModal({ news: n, onSaved: () => renderAktuality(container) });
        });
    });
}

function renderNewsRow(n, admin) {
    return `
        <div class="tip-row">
            <div class="tip-title">${esc(n.title)}</div>
            <div class="tip-meta">
                <span class="tip-notes-inline">${esc(excerpt(n.body))}</span>
            </div>
            <div class="tip-voteline">
                <span class="tip-by">${fmtDate(n.published_at || n.created_at)}</span>
                <span style="margin-left:auto; display:flex; gap:6px;">
                    <button class="btn btn-sm" data-edit="${n.id}">Upravit</button>
                    ${admin ? `<button class="btn btn-sm rep-btn-danger" data-del="${n.id}"
                            title="Smazat aktualitu (jen správce)">🗑</button>` : ''}
                </span>
            </div>
        </div>
    `;
}

// Datum z DB → hodnota pro <input type="datetime-local"> (YYYY-MM-DDTHH:MM).
function toInput(iso) {
    return (iso || '').replace(' ', 'T').slice(0, 16);
}

function openNewsModal({ news, onSaved }) {
    let m = document.getElementById('news-modal');
    if (m) m.remove();
    m = document.createElement('div');
    m.id = 'news-modal';
    m.className = 'modal-overlay open';
    m.innerHTML = `
        <div class="modal-window" style="max-width: 560px;">
            <div class="modal-head">
                <h2>Upravit aktualitu</h2>
                <button class="modal-close" type="button">×</button>
            </div>
            <form id="ne-form">
                <div class="modal-body">
                    <label class="se-field">
                        <span>Nadpis</span>
                        <input type="text" name="title" required maxlength="160"
                               value="${esc(news.title || '')}">
                    </label>
                    <label class="se-field" style="margin-top:12px;">
                        <span>Datum a čas vložení</span>
                        <input type="datetime-local" name="published_at"
                               value="${esc(toInput(news.published_at || news.created_at))}">
                    </label>
                    <label class="se-field" style="margin-top:12px;">
                        <span>Text</span>
                        <textarea name="body" rows="6" required>${esc(news.body || '')}</textarea>
                    </label>
                    <p id="ne-error" style="color:var(--accent); font-size:13px; margin-top:10px; display:none;"></p>
                </div>
                <div class="modal-foot">
                    <button class="btn" type="button" id="ne-cancel">Zrušit</button>
                    <button class="btn btn-primary" type="submit">Uložit změny</button>
                </div>
            </form>
        </div>
    `;
    document.body.appendChild(m);

    const close = () => m.remove();
    m.querySelector('.modal-close').addEventListener('click', close);
    m.querySelector('#ne-cancel').addEventListener('click', close);
    m.addEventListener('click', (e) => { if (e.target === m) close(); });

    m.querySelector('#ne-form').addEventListener('submit', async (e) => {
        e.preventDefault();
        const errEl = m.querySelector('#ne-error');
        errEl.style.display = 'none';
        const fd = new FormData(e.target);
        const title = fd.get('title').trim();
        const body = fd.get('body').trim();
        const dt = fd.get('published_at');
        if (!title || !body) {
            errEl.textContent = 'Vyplň prosím nadpis i text.';
            errEl.style.display = 'block';
            return;
        }
        const { error } = await supabase.from('web_news').update({
            title,
            body,
            published_at: dt || news.published_at,
            updated_at: new Date().toISOString()
        }).eq('id', news.id);
        if (error) {
            errEl.textContent = 'Uložení selhalo: ' + error.message;
            errEl.style.display = 'block';
            return;
        }
        close();
        onSaved?.();
    });
}
